module.exports = __webpack_public_path__ + "static/media/g_levels_3-6.ee4efa4d.png";